import { Chess } from 'chess.js';

const CHESSBOARD = {
  COLOR_VARIANTS: {
    "YELLOW": "#FFD70090",  // Yellow with 100% opacity
    "RED": "#ff005090",
    "GREEN": "#58b04790", // Green with 100% opacity
    "BLUE": "#00F2EA90", // Blue with 100% opacity
    "BLACK": "#000000"


  },
  MOVE_TYPES: {
    COMMENT: "COMMENT",
  },
  START_POSITION: new Chess().fen()
};

const MOCKS = {
  GAMES: [
    {
      id: '1',
      tags: ["OPENING"],
      username: 'chessmaster1',
      caption: 'A great match with unexpected moves!',
      fen: CHESSBOARD.START_POSITION,
      comments: [
        {
          id: '0',
          user: 'Orlando',
          content: 'Great game, well played!'
        }
      ],
      suggestedMoves: [],
      starredMoves: ['2', '6|0:0'],
      moves: [
        {
          notation: 'e4',
          content: 'white starts the game',
          arrows: [["e2", "e4", CHESSBOARD.COLOR_VARIANTS.BLUE]],
          highlightedSquares: {
            "e4": { backgroundColor: CHESSBOARD.COLOR_VARIANTS.BLUE },
            "d4": { backgroundColor: CHESSBOARD.COLOR_VARIANTS.GREEN },
          },
        },
        { notation: 'e5', content: '' },
        { notation: 'Nf3', content: '' },
        { notation: 'Nc6', content: '' },
        { notation: 'Bc4', content: '' },
        { notation: 'Bc5', content: '' },
        {
          notation: 'c3',
          content: '',
          variations: [
            [
              { notation: 'Nc3', content: 'white develops the second knight' },
              {
                notation: 'Nge7',
                content: '',
                highlightedSquares: {
                  "f7": { backgroundColor: CHESSBOARD.COLOR_VARIANTS.BLUE },
                  "f2": { backgroundColor: CHESSBOARD.COLOR_VARIANTS.GREEN },
                },
                arrows: [["f2", "f7", CHESSBOARD.COLOR_VARIANTS.RED]],
                variations: [
                  [
                    { notation: 'd6', content: '' },
                  ]
                ]
              },
            ],
            [
              { notation: 'b4', content: '' },
              // eslint-disable-next-line no-use-before-define
              { notation: 'b5', content: 'dubious move', creator: { id: '0', type: CHESSBOARD.MOVE_TYPES.COMMENT } },
            ],
          ]
        },
        { notation: 'Nf6', content: '' },
      ],
    },
    {
      id: '2',
      tags: ["OPENING"],
      username: 'queenmovepro',
      caption: 'Can you find the winning moves in this puzzle?',
      fen: 'r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - 0 1',
      comments: [
        {
          user: 'Kathleen',
          content: 'I love these puzzles, so challenging!'
        }
      ],
      suggestedMoves: [],
      moves: [
        { notation: 'Ng5', content: '' },
        { notation: 'Ng4', content: '' },
        { notation: 'Qf3', content: '' },
        { notation: 'Nxf2', content: '' },
        { notation: 'Qf7', content: '' },
      ],
    },
  ]
};

export const TAGS = {
  "Openings": { label: "Openings", className: "tag-openings", color: "black", background: "sandybrown", sisterGroup: "OPENINGS" },

  "Puzzle": { label: "Puzzle", className: "tag-puzzle", color: "black", background: "aquamarine", sisterGroup: "1" },
  // "Challenge": { label: "Challenge", className: "tag-challenge", color: "black", background: "aquamarine", sisterGroup: "2" },

  "The-Pros": { label: "The Pros", className: "tag-the-pros", color: "black", background: "gold", sisterGroup: "4" },


  "Middlegame": { label: "Middlegame", className: "tag-middlegame", color: "black", background: "cornflowerblue", sisterGroup: "GAME_PHASE" },
  "Endgame": { label: "Endgame", className: "tag-endgame", color: "black", background: "cornflowerblue", sisterGroup: "GAME_PHASE" },
  "Full Game": { label: "Full Game", className: "tag-full-game", color: "black", background: "cornflowerblue", sisterGroup: "GAME_PHASE" },


  "Positional": { label: "Positional", className: "tag-positional", color: "black", background: "palevioletred", sisterGroup: "STYLE" },
  "Tactical": { label: "Tactical", className: "tag-tactical", color: "black", background: "palevioletred", sisterGroup: "STYLE" },

  "Lesson": { label: "Lesson", className: "tag-lesson", color: "black", background: "lightgrey", sisterGroup: "3" },

  "Study": { label: "Study", className: "tag-study", color: "black", background: "lightgrey", sisterGroup: "STUDY" },

  "Brilliance": { label: "Brilliance", className: "tag-brilliance", color: "black", background: "#00f2ea", sisterGroup: "BRILLIANCE" },

  "Immortal": { label: "Immortal", className: "tag-immortal", color: "black", background: "peru", sisterGroup: "IMMORTAL" },

  "Bullet": { label: "Bullet", className: "tag-bullet", color: "black", background: "gold", sisterGroup: "TIME_CONTROL" },
  "Blitz": { label: "Blitz", className: "tag-blitz", color: "black", background: "gold", sisterGroup: "TIME_CONTROL" },
  "Rapid": { label: "Rapid", className: "tag-rapid", color: "black", background: "gold", sisterGroup: "TIME_CONTROL" },
  "Classical": { label: "Classical", className: "tag-classical", color: "black", background: "gold", sisterGroup: "TIME_CONTROL" },

  "Blunder": { label: "Blunder", className: "tag-blunders", color: "black", background: "navajowhite", sisterGroup: "BLUNDER" },

  "Meme": { label: "Meme", className: "tag-meme", color: "white", fontWeight: "bold", background: "linear-gradient(to right, red, orange, yellow, green, blue, indigo, violet)", sisterGroup: "MEME" },
};

// Tags to hide from Portal navigation for all users
export const HIDDEN_TAGS = ["Blunder", "Meme", "The-Pros", "Middlegame", "Endgame", "Full Game", "Positional", "Study", "Immortal", "Bullet", "Blitz", "Rapid"];




// export const allowedEcoGroups = {
//   "Ruy Lopez": ["C60", "C61", "C62", "C63", "C64", "C65", "C66", "C67", "C68", "C69"],
//   "Italian Game": ["C50", "C51", "C52", "C53", "C54"],
//   "Scotch Game": ["C44", "C45"],
//   "Four Knights": ["C46", "C47", "C48", "C49"],
//   "Petrov's Defense": ["C42", "C43"],
//   "Sicilian Defense": [
//     "B20", "B21", "B22", "B23", "B24", "B25", "B26", "B27", "B28", "B29",
//     "B30", "B31", "B32", "B33", "B34", "B35", "B36", "B37", "B38", "B39",
//     "B40", "B41", "B42", "B43", "B44", "B45", "B46", "B47", "B48", "B49",
//     "B50", "B51", "B52", "B53", "B54", "B55", "B56", "B57", "B58", "B59"
//   ],
//   "French Defense": ["C00", "C01", "C02", "C03", "C04", "C05", "C06", "C07", "C08", "C09"],
//   "Caro-Kann Defense": ["B10", "B11", "B12", "B13", "B14", "B15", "B16", "B17", "B18", "B19"],
//   "Pirc Defense": ["B07", "B08", "B09"],
//   "Queen's Gambit": ["D06", "D30", "D31", "D32", "D33", "D34", "D35", "D36"],
//   "Slav Defense": ["D10", "D11", "D12", "D13", "D14", "D15", "D16", "D17"],
//   "King's Indian Defense": ["E60", "E61", "E62", "E63", "E64", "E65", "E66", "E67", "E68", "E69"],
//   "Grunfeld Defense": ["D70", "D71", "D72", "D73", "D74", "D75", "D76", "D77", "D78", "D79"],
//   "Nimzo-Indian Defense": ["E20", "E21", "E22", "E23", "E24", "E25"],
//   "English Opening": ["A10", "A11", "A12", "A13", "A14", "A15", "A16", "A17", "A18", "A19"],
//   "Reti Opening": ["A04", "A05", "A06"]
// };


export const allowedEcoGroups = {
  "Ruy Lopez": ["C60", "C61", "C62", "C63", "C64", "C65", "C66", "C67", "C68", "C69"],
  "Italian Game": ["C50", "C51", "C52", "C53", "C54"],
  "Scotch Game": ["C44", "C45"],
  "Petrov's Defense": ["C42", "C43"],
  "Sicilian Defense": [
    "B20", "B21", "B22", "B23", "B24", "B25", "B26", "B27", "B28", "B29",
    "B30", "B31", "B32", "B33", "B34", "B35", "B36", "B37", "B38", "B39",
    "B40", "B41", "B42", "B43", "B44", "B45", "B46", "B47", "B48", "B49",
    "B50", "B51", "B52", "B53", "B54", "B55", "B56", "B57", "B58", "B59"
  ],
  "French Defense": ["C00", "C01", "C02", "C03", "C04", "C05", "C06", "C07", "C08", "C09"],
  "Caro-Kann Defense": ["B10", "B11", "B12", "B13", "B14", "B15", "B16", "B17", "B18", "B19"],
  "Pirc Defense": ["B07", "B08", "B09"],
  "Queen's Gambit": ["D06", "D30", "D31", "D32", "D33", "D34", "D35", "D36"],
  "Slav Defense": ["D10", "D11", "D12", "D13", "D14", "D15", "D16", "D17"],
  "King's Indian Defense": ["E60", "E61", "E62", "E63", "E64", "E65", "E66", "E67", "E68", "E69"],
  "Grunfeld Defense": ["D70", "D71", "D72", "D73", "D74", "D75", "D76", "D77", "D78", "D79"],
  "Nimzo-Indian Defense": ["E20", "E21", "E22", "E23", "E24", "E25"],
  "English Opening": ["A10", "A11", "A12", "A13", "A14", "A15", "A16", "A17", "A18", "A19"],
  "Reti Opening": ["A04", "A05", "A06"],
  "Benoni": ["A56", "A57", "A58", "A59", "A60", "A61", "A62", "A63", "A64", "A65", "A66", "A67", "A68", "A69"],
  "Dutch Defense": ["A80", "A81", "A82", "A83", "A84", "A85", "A86", "A87", "A88", "A89"],
  "Benko Gambit": ["A57", "A58", "A59"],
  "Trompowsky Attack": ["A45", "A46"],
  "Torre Attack": ["A46", "A48", "A49"],
  "Richter-Veresov Attack": ["D01"],
  "Alekhine Defense": ["B02", "B03", "B04", "B05"],
  "Modern Defense": ["B06"],
  "Scandinavian Defense": ["B01"],
  "Vienna": ["C25", "C26", "C27", "C28", "C29"],
  "Centre Game": ["C21", "C22"],
  "King's Gambit": ["C30", "C31", "C32", "C33", "C34", "C35", "C36", "C37", "C38", "C39"],
  "Philidor Defense": ["C41"],
  "Hungarian Defense": ["C50"],
  "Scotch Gambit": ["C44"],
  "King's Pawn": ["C20"],
  "Queen's Indian Defense": ["E12", "E13", "E14", "E15", "E16", "E17"],
  "Catalan Defense": ["E01", "E02", "E03", "E04", "E05"],
  "Bogo-Indian Defense": ["E11"]
};






// New DIFFICULTY constant
export const DIFFICULTY = {
  "All Levels": { label: "All Levels", className: "difficulty-all-levels", color: "black", background: "palegreen" },
  "Beginner": { label: "Beginner", className: "difficulty-beginner", color: "black", background: "palegreen" },
  "Intermediate": { label: "Intermediate", className: "difficulty-intermediate", color: "black", background: "palegreen" },
  "Advanced": { label: "Advanced", className: "difficulty-advanced", color: "black", background: "palegreen" },
  "Master": { label: "Master", className: "difficulty-master", color: "black", background: "palegreen" },
};

const VISIBILITIES = [
  "Public",
  "Private",
  // "Drafts",
];

const LICHESS_BASE_URL = "https://lichess.org";
// const LICHESS_BASE_URL = "http://localhost:8080";
const LICHESS_SCOPES = ["email:read", "preference:read", "challenge:write", "board:play"];


export default {
  CHESSBOARD,
  MOCKS,
  TAGS,
  DIFFICULTY,
  VISIBILITIES,
  LICHESS_BASE_URL,
  LICHESS_SCOPES
};